import { FC, ReactNode } from 'react';
import { Table as TanstackTable, useReactTable, getPaginationRowModel } from '@tanstack/react-table';
import {
    RowData,
    getCoreRowModel,
    ColumnDef,
    TableOptions,
    Column,
    getFilteredRowModel,
    getFacetedRowModel,
    getFacetedUniqueValues,
    CellContext,
    Row,
} from '@tanstack/table-core';

export { getPaginationRowModel };

export interface TableProps<T> {
    table: TanstackTable<T>;
    emptyPage: ReactNode | FC;
    noResults: ReactNode | FC;
    hideResultTitle?: boolean;
    onRowClick?: (row: Row<T>) => void;
    onRowImpression?: (row: Row<T>) => void;
    totalCount?: number;
}

export enum BriefsTableFilterType {
    Text = 'text',
    Select = 'select',
    MultiSelect = 'multiSelect',
}

// Consumers should not depend on the tanstack/react-table package
export function useBriefsTable<TData extends RowData>(options: TableOptions<TData>): TanstackTable<TData> {
    return useReactTable(options);
}
export {
    getCoreRowModel,
    ColumnDef,
    Column,
    getFilteredRowModel,
    getFacetedRowModel,
    getFacetedUniqueValues,
    CellContext,
    Row,
};

export type ItemValue = string | number | undefined;
